module.exports = __webpack_public_path__ + "static/media/MentorAlistair.81f4eafe.jpg";